<template lang="html">
  <div class="timeline-item" v-show="context != null" ref="container">
    <div class="timeline-marker bg-primary is-icon"><i class="bi-check"></i></div>
    <div class="timeline-content" style="width: 100%;">
      <div class="card h-100">
        <div class="card-body p-3">
          <keep-alive>
            <component
                v-if="content.context.data"
                :email_set="email_set"
                :is="'State'+context.class_name"
                v-bind="content"
                :review="review"
                @state:update_data="saveInternalState"
                @state:set_level="setLevel"
                @state:delete_state="deleteState"
                :can_delete="can_delete"
                :human_created_on="human_created_on"
            ></component>
          </keep-alive>
        </div>
        <div class="p-3">
          <div class="btn-group" role="group">
            <button
                v-for="(action, index) in listActionsWithClass"
                :key="action.slug"
                :class="action.classes"
                @click="callAction(action.slug)"
                :disabled="context.active == false"
                v-if="show_action(action) && index < 3"> <!-- Affiche les trois premiers -->
              {{ getActionName(action.name) }}
            </button>

            <!-- Menu déroulant pour les autres actions -->
            <div class="btn-group" role="group" v-if="prioritizedActions('mhr').length > 3">
              <button
                  id="btnGroupDrop2"
                  type="button"
                  class="btn btn-outline-primary btn-sm dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                Autre
              </button>
              <div class="dropdown-menu" aria-labelledby="btnGroupDrop2">
                <a
                    v-for="(action, index) in prioritizedActions('mhr').slice(3)"
                    :key="action.slug"
                    class="dropdown-item"
                    :class="{'action-disabled': context.active !== true}"
                    @click.prevent="callAction(action.slug)"
                    v-show="show_action(action)">
                  {{ action.name }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ReviewStateNotification
          @update-email-set="handleEmailSetUpdate"
          :state="content.context"
          :to_gathering="to_gathering"
      />
    </div>
    <Modal :show="showWarning"
           v-on:modaldissmiss="showWarning=false"
           v-on:modalconfirm="deleteConfirmed()"
           title="Supprimer l'état?"
           text="Etes-vous sur de vouloir supprimer l'état?">
    </Modal>
  </div>
</template>

<script>
import StateModified from "@/components/review_states/StateModified.vue";
import StateNew from "@/components/review_states/StateNew.vue";
import StateSignalingWriting from "@/components/review_states/StateSignalingWriting.vue";
import StateInformationNeeded from "@/components/review_states/StateInformationNeeded.vue";
import StateWaitingForInformation from "@/components/review_states/StateWaitingForInformation.vue";
import StateClassified from "@/components/review_states/StateClassified.vue";
import StateSignalingSent from "@/components/review_states/StateSignalingSent.vue";
import StateAnswerWriting from "@/components/review_states/StateAnswerWriting.vue";
import StateAnswerTextValidation from "@/components/review_states/StateAnswerTextValidation.vue";
import StateAnswerAccepted from "@/components/review_states/StateAnswerAccepted.vue";
import StateAnswerPublished from "@/components/review_states/StateAnswerPublished.vue";
import StateTranslationNeeded from "@/components/review_states/StateTranslationNeeded.vue";
import StateStratalisPublication from "@/components/review_states/StateStratalisPublication.vue";
import StatePublicationError from "@/components/review_states/StatePublicationError.vue";

import ReviewStateNotification from "@/components/ReviewStateNotification.vue";
import Modal from "@/components/Modal";

import UPDATE_STATE_DATA from '@/gql/mutations/updateStateData.graphql';
import STATE_CALL_ACTION from '@/gql/mutations/stateCallAction.graphql';
import STATE_DELETE from '@/gql/mutations/deleteReviewState.graphql';
import { gqlMutation } from '@/gqlClient.js';
import settings from "@/settings.coffee";
import moment from "moment";
import tools from "@/tools.js";

moment.locale("fr");

export default {
  name: "ReviewState",
  components: {
    StateNew,
    StateModified,
    StateSignalingWriting,
    StateInformationNeeded,
    StateClassified,
    StateSignalingSent,
    StateAnswerWriting,
    StateAnswerAccepted,
    StateAnswerPublished,
    StateTranslationNeeded,
    ReviewStateNotification,
    StateAnswerTextValidation,
    StateStratalisPublication,
    StatePublicationError,
    Modal,
    StateWaitingForInformation
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    review: {
      type: Object,
      required: true
    },
    can_delete: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showWarning: false,
      show_menu: false,
      loading: false,
      loading_error: false,
      level: "default",
      email_set: []
    };
  },
  computed: {

    listActionsWithClass() {
      return this.prioritizedActions('mhr').map(action => {
        const classes = ['btn', 'btn-sm', 'btn-primary'];

        const isPublishViaStratalis = (
            !this.review.platform.publication_auto_via_api &&
            action.slug === 'publish_via_stratalis'
        );

        const isAcceptAnswerAndTextEmpty = (
            action.slug === 'accept_answer' &&
            this.isEmpty(this.context.data.text_fr) &&
            this.isEmpty(this.context.data.text_native)
        );

        if (isPublishViaStratalis || isAcceptAnswerAndTextEmpty) {
          classes.push('disabled');
        }

        return {
          ...action,
          classes
        };
      });
    },
    to_gathering() {
      return this.context.class_name === "AnswerWriting";
    },
    content() {
      if (this.context.data) {
        if (typeof this.context.data === "string") {
          this.context.data = JSON.parse(this.context.data);
        }
      }
      return {
        context: tools.deep_copy(this.context)
      };
    },
    class_state_active() {
      return {
        "is-primary": this.context.active
      };
    },
    human_created_on() {
      return (
          moment(this.context.created_on).fromNow() +
          " (" +
          moment(this.context.created_on).format("DD/MM/YYYY HH:mm:ss") +
          ")"
      );
    },
  },
  methods: {
    getActionName(name) {
      switch (name) {
        case 'Réponse publiée':
          return 'Je publie moi-même';
        default:
          return name;
      }
    },
    isEmpty(value) {
      return value === null || value === '';
    },
    prioritizedActions(who) {
      if (this.context.class_name === "New") {
        const priorActions = [];
        const otherActions = [];

        this.context.list_actions.forEach(action => {
          if (action.slug === "classify") priorActions[0] = action;
          else if (action.slug === "write_an_answer") priorActions[1] = action;
          else if (action.slug === "ask_information") priorActions[2] = action;
          else otherActions.push(action);
        });

        return priorActions.filter(Boolean).concat(otherActions);
      } else {
        return this.context.list_actions.filter(act =>
            act.groups.includes(who)
        );
      }
    },
    deleteState() {
      this.$store.commit("delete_edited_fields", {key: "text_native"});
      this.$store.commit("delete_edited_fields", {key: "text_fr"});
      this.showWarning = true;
    },
    deleteConfirmed() {
      this.showWarning = false;
      this.$emit("FlowDetail:delete_state");
    },
    setLevel(level) {
      this.level = level;
    },
    async saveInternalState(data) {
      this.loading = true;
      let serialized = JSON.stringify(data);
      serialized = tools.b64_encode(serialized);

      try {
        await gqlMutation(UPDATE_STATE_DATA, { uid: this.context.uid, serialized: serialized });
        this.loading = false;
        this.$store.dispatch("notify", {
          text: "Enregistrement effectué",
          seconds: 2,
          level: "success"
        });
      } catch (e) {
        this.loading = false;
        console.error(e)
        this.$store.dispatch("notify", {
          text: "Erreur à l'enregistrement",
          seconds: 2,
          level: "danger"
        });
      }
    },
    async callAction(slug) {
      if (this.context.active) {
        let {allow, notify_text} = tools.check_modified_fields(this.$store);
        // data.text_fr || data.text_native is empty allow false, and notify_text is set to "Veuillez remplir le texte avant de continuer"
        if (slug === "accept_answer" && !this.context.data.text_fr && !this.context.data.text_native) {
          allow = false;
          notify_text = "Veuillez remplir le texte avant de continuer";
        }
        if (allow) {
          await gqlMutation(STATE_CALL_ACTION, { uid: this.context.uid, action_slug: slug });
        } else {
          this.$store.dispatch("notify", {
            text: notify_text,
            seconds: 5,
            level: "danger"
          });
        }
      }
    },
    show_action(action) {
      return action.groups.includes("mhr");
    },
    async delete() {
      await gqlMutation(STATE_DELETE, { uid: this.context.uid });
    },
    handleEmailSetUpdate(newEmailSet) {
      this.email_set = newEmailSet;
    }
  },
  updated() {
    this.setLevel(this.context.active ? "primary" : "default");
  },
  mounted() {
    this.loading = false;
  },
  created() {
    this.loading = true;
  }
};
</script>

<style lang="scss" scoped>
.clickable {
  cursor: pointer;
}

.state {
  background-color: #eee;
}

.timeline-heading-custom {
  font-size: 0.9em;
  // color: red;
}

.timeline .timeline-item {
  display: -webkit-box;
  //margin: 0 !important;

}

.is-icon {
  font-size: 20px;
}

.custom-scroll {
  scrollbar-width: none;
}

.btn-group {
  display: -webkit-inline-box;
}

.dropdown-item.action-disabled {
  cursor: not-allowed;
}
</style>
